import { AlertTriangle } from 'lucide-react'

// admin 홈 설정에서 hero.mode === 'maintenance'일 때 동적 히어로 대신 표시하는 점검 배너.
// 기존 앱의 "막차 임박"/알러지 경고와 같은 warning 팔레트를 그대로 쓴다(App.jsx 참고).
export default function HomeMaintenanceBanner({ message, isDark = false }) {
  return (
    <div
      role="status"
      style={{
        borderRadius: 16,
        padding: '16px 16px',
        display: 'flex',
        alignItems: 'flex-start',
        gap: 10,
        background: isDark ? '#3a2f12' : '#fff7db',
        color: isDark ? '#ffd166' : '#8a5a00',
        border: `1px solid ${isDark ? '#5a4a1e' : '#f0e0a0'}`,
      }}
    >
      <AlertTriangle size={18} strokeWidth={2} style={{ flexShrink: 0, marginTop: 1 }} />
      <p style={{ margin: 0, fontSize: 13, fontWeight: 700, lineHeight: 1.5, whiteSpace: 'pre-wrap' }}>{message}</p>
    </div>
  )
}
